<template>
    <v-dialog
        :hide-overlay="true"
        :persistent="true"
        v-model="alertModal"
        width="1000"
    >
        <v-card class="pt-0">
            <v-app-bar
                flat
                color="rgba(0, 0, 0, 0)"
                style="background: rgb(26, 57, 88)"
            >
                <v-toolbar-title
                    class="text-h6 white--text pl-0"
                    v-if="alertDetail"
                >
                    {{
                        "More Details - " +
                        (alertDetail && alertDetail.trigger_time.split(" ")[1])
                    }}
                </v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn color="white" icon @click="closeModal"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-app-bar>

            <v-card-text style="padding-top: 14px">
                <v-row v-for="type in Object.keys(details)">
                    <v-col cols="12" class="pb-1"
                        ><h2>{{ nameMap[type] }}</h2></v-col
                    >
                    <template v-for="field in alertField[type]">
                        <v-col cols="3" class="pb-1 pt-1">
                            <strong>{{ field.text }}</strong>
                        </v-col>
                        <v-col
                            cols="3"
                            class="pb-1 pt-1"
                            style="text-align: center"
                            >{{
                                typeof details[type][field.key] === "number"
                                    ? numberWithCommas(details[type][field.key])
                                    : details[type][field.key]
                            }}</v-col
                        >
                    </template>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="closeModal">{{
                    $t("common.form.close")
                }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { helper } from "@components/mixins/helper";

export default {
    props: {
        alertModal: false,
        alertDetail: null,
        closeModal: Function,
    },
    mixins: [helper],
    data() {
        return {
            alertField: {
                MSG_TYPE_MONITOR_FAST_CLOSED_TRADE: [
                    {
                        text: "Ultra-fast closes (<30s) — PnL",
                        key: "shortPnlSum",
                    },
                    {
                        text: "Ultra-fast closes (<30s) — Trades",
                        key: "shortCount",
                    },
                    {
                        text: "Fast closes (30-120s) — PnL",
                        key: "mediumPnlSum",
                    },
                    {
                        text: "Fast closes (30-120s) — Trades",
                        key: "mediumCount",
                    },
                ],
                MSG_TYPE_MONITOR_LOW_LIQUIDITY_ARBITRAGE: [
                    {
                        text: "Top Symbol",
                        key: "topSymbol",
                    },
                    {
                        text: "Session Total Profit",
                        key: "lowLiquidityProfit",
                    },
                ],
                MSG_TYPE_MONITOR_TODAY_OPENED_LARGE_PNL: [
                    {
                        text: "Triggered Profit",
                        key: "sumProfit",
                    },
                ],
                MSG_TYPE_MONITOR_HIGH_VOLUME_USD: [
                    {
                        text: "Volume USD",
                        key: "sumVolumeUSD",
                    },
                    {
                        text: "Std Lot",
                        key: "std_lot",
                    },
                ],
                MSG_TYPE_MONITOR_HIGH_TRADE_COUNT: [
                    {
                        text: "Trade Count",
                        key: "todayOpenTradeCount",
                    },
                ],
            },
            nameMap: {
                MSG_TYPE_MONITOR_FAST_CLOSED_TRADE: "Fast Close",
                MSG_TYPE_MONITOR_HIGH_VOLUME_USD: "High Volume USD",
                MSG_TYPE_MONITOR_HIGH_TRADE_COUNT: "High Trades",
                MSG_TYPE_MONITOR_TODAY_OPENED_LARGE_PNL: "Large PNL",
                MSG_TYPE_MONITOR_LOW_LIQUIDITY_ARBITRAGE:
                    "Low Liquidity Arbitrage",
            },
        };
    },
    computed: {
        details() {
            const result = {};
            if (!this.alertDetail) return result;
            if (typeof this.alertDetail?.alert_type == "string") {
                result[this.alertDetail.alert_type] = JSON.parse(
                    this.alertDetail?.alert_body
                );
                return result;
            } else {
                Object.keys(this.alertDetail.alert_type).map((key) => {
                    if (Object.keys(this.alertField).includes(key)) {
                        result[key] = JSON.parse(
                            this.alertDetail.alert_type[key].alert_body
                        );
                    }
                });
                return result;
            }
        },
    },
};
</script>
